<template>
  <div
    class="my-6 p-4 bg-muted/50 border border-border rounded-lg"
    role="note"
    :aria-label="ariaLabel"
  >
    <div class="flex items-start gap-3">
      <Icon
        v-if="icon"
        :name="icon"
        size="20"
        class="text-primary shrink-0 mt-0.5"
        aria-hidden="true"
      />
      <div class="flex-1 min-w-0">
        <h2 class="text-sm font-semibold text-foreground mb-2">
          {{ title }}
        </h2>
        <div class="text-sm text-foreground/80 leading-relaxed">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue';
/**
 * Blog TL;DR Component
 *
 * Provides a concise summary container for articles.
 * Usage in MDC:
 * ::blog-tldr
 * Your quick summary content (lists / short paragraphs)
 * ::
 */
interface Props {
  /** Heading text displayed above the summary */
  title?: string;
  /** Optional icon name (uses internal Icon component) */
  icon?: string;
  /** Optional aria-label override */
  ariaLabel?: string;
}

const props = withDefaults(defineProps<Props>(), {
  title: 'TL;DR',
  icon: 'tabler:bolt',
  ariaLabel: 'Article summary',
});

const { title, icon, ariaLabel } = toRefs(props);
</script>
